import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconContains(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3.2875 8.7125C3.47917 8.90417 3.71667 9 4 9C4.28333 9 4.52083 8.90417 4.7125 8.7125C4.90417 8.52083 5 8.28333 5 8V5H8C8.28333 5 8.52083 4.90417 8.7125 4.7125C8.90417 4.52083 9 4.28333 9 4C9 3.71667 8.90417 3.47917 8.7125 3.2875C8.52083 3.09583 8.28333 3 8 3H5C4.45 3 3.97917 3.19583 3.5875 3.5875C3.19583 3.97917 3 4.45 3 5V8C3 8.28333 3.09583 8.52083 3.2875 8.7125Z"
        fill="currentColor"
      />
      <path
        d="M19.2875 8.7125C19.4792 8.90417 19.7167 9 20 9C20.2833 9 20.5208 8.90417 20.7125 8.7125C20.9042 8.52083 21 8.28333 21 8V5C21 4.45 20.8042 3.97917 20.4125 3.5875C20.0208 3.19583 19.55 3 19 3H16C15.7167 3 15.4792 3.09583 15.2875 3.2875C15.0958 3.47917 15 3.71667 15 4C15 4.28333 15.0958 4.52083 15.2875 4.7125C15.4792 4.90417 15.7167 5 16 5H19V8C19 8.28333 19.0958 8.52083 19.2875 8.7125Z"
        fill="currentColor"
      />
      <path
        d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V16C3 15.7167 3.09583 15.4792 3.2875 15.2875C3.47917 15.0958 3.71667 15 4 15C4.28333 15 4.52083 15.0958 4.7125 15.2875C4.90417 15.4792 5 15.7167 5 16V19H8C8.28333 19 8.52083 19.0958 8.7125 19.2875C8.90417 19.4792 9 19.7167 9 20C9 20.2833 8.90417 20.5208 8.7125 20.7125C8.52083 20.9042 8.28333 21 8 21H5Z"
        fill="currentColor"
      />
      <path
        d="M15.2875 20.7125C15.4792 20.9042 15.7167 21 16 21H19C19.55 21 20.0208 20.8042 20.4125 20.4125C20.8042 20.0208 21 19.55 21 19V16C21 15.7167 20.9042 15.4792 20.7125 15.2875C20.5208 15.0958 20.2833 15 20 15C19.7167 15 19.4792 15.0958 19.2875 15.2875C19.0958 15.4792 19 15.7167 19 16V19H16C15.7167 19 15.4792 19.0958 15.2875 19.2875C15.0958 19.4792 15 19.7167 15 20C15 20.2833 15.0958 20.5208 15.2875 20.7125Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
